<button mat-button color="primary" id="{{userQuickActionButton.id}}" [attr.azure-id]="userQuickActionButton.azureId"
        class="{{userQuickActionButton.class}} btn landing-page-link" (click)="onClick()"
        [disabled]="buttonDisabled || isLoading">
  <app-fn-ui-icon class="landing-page-icon" icon="{{userQuickActionButton.icon}}" size="32px"></app-fn-ui-icon>
  <span>{{userQuickActionButton.text | translate}}</span>
</button>
